"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadFeature = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var attachment_object_1 = require("../../bff/lib/attachment-object");
var attachment_dropzone_1 = require("../../components/attachment-dropzone");
function FileUploadFeature(props) {
    var _this = this;
    var refs = props.refs, onDrop = props.onDrop, onSubmit = props.onSubmit, _a = props.initialAttachments, initialAttachments = _a === void 0 ? undefined : _a, documentTypes = props.documentTypes, defaultDocumentType = props.defaultDocumentType;
    var _b = (0, react_1.useState)(false), isSubmitting = _b[0], setIsSubmitting = _b[1];
    var _c = (0, react_1.useState)(true), disableForm = _c[0], setDisableForm = _c[1];
    // format any initial files to attachment objects
    var formattedInitialAttachments = initialAttachments === null || initialAttachments === void 0 ? void 0 : initialAttachments.map(attachment_object_1.formatFileToAttachmentObject);
    function handleSubmit() {
        if (onSubmit)
            onSubmit();
    }
    var form = (0, formik_1.useFormik)({
        initialValues: {
            attachments: [],
        },
        onSubmit: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                setIsSubmitting(true);
                handleSubmit();
                return [2 /*return*/];
            });
        }); },
    });
    return (react_1.default.createElement(core_ui_1.Card, null,
        react_1.default.createElement("form", { onSubmit: form.handleSubmit },
            react_1.default.createElement(core_ui_1.Padding, { top: 40, x: 48, bottom: 56 },
                react_1.default.createElement(core_ui_1.Title, { size: 24, weight: 100, as: "h2" }, "Upload documents or emails"),
                react_1.default.createElement(core_ui_1.Spacing, { height: 32 }),
                react_1.default.createElement(attachment_dropzone_1.AttachmentDropzone, { initialAttachments: formattedInitialAttachments, refs: refs, label: "Upload attachments", onChange: function (attachments, performingApiRequest) {
                        // prevent form from submitting while uploading/updating
                        setDisableForm(attachments.length === 0 || performingApiRequest);
                        if (onDrop)
                            onDrop(attachments);
                    }, documentTypes: documentTypes, defaultDocumentType: defaultDocumentType })),
            react_1.default.createElement(core_ui_1.Divider, null),
            react_1.default.createElement(core_ui_1.Spacing, { height: 32 }),
            react_1.default.createElement(core_ui_1.Flexbox, { justifyContent: "flex-end", paddingRight: 24, paddingLeft: 24, paddingBottom: 24 },
                react_1.default.createElement(core_ui_1.Button, { disabled: isSubmitting || disableForm, type: "submit", loading: isSubmitting, testId: "upload-attachments-submit" }, "Finished")))));
}
exports.FileUploadFeature = FileUploadFeature;
